import {
  TCategoryProductSheet,
  TProductProfileApiResponse,
  TMenuItemProfileApiResponse,
  TProductSheet,
  TProductSheetResponse,
} from '../../types/product';
import { TCommodityCategory } from '../../types/commodity';

export function transformProductSheetToApiRequest(productSheet: TProductSheet) {
  return {
    onProductionSheet: Boolean(productSheet.display),
    fresh: Boolean(productSheet.fresh),
    shelfLife: Number(productSheet.shelfLife),
    shelfLifeUnit: Number(productSheet.shelfLifeUnit),
    unitsOfMeasure: {
      units: productSheet.unitsOfMeasure.units.map(unit => unit.id),
      default: Number(productSheet.unitsOfMeasure.default),
    },
  };
}

export function putCategoryValuesToPayload(
  payload: any,
  category?: TCommodityCategory,
) {
  payload.isParent = category?.isParent;
  return payload;
}

export function transformCategoryProductSheetToApiRequest(
  productSheet: TCategoryProductSheet,
) {
  return {
    display: Boolean(productSheet.display),
    fresh: Boolean(productSheet.fresh),
    shelfLife: Number(productSheet.shelfLife),
    shelfLifeUnit: Number(productSheet.shelfLifeUnit),
    unitsOfMeasure: {
      units: productSheet.unitsOfMeasure.units.map(unit => unit.id),
      default: Number(productSheet.unitsOfMeasure.default),
    },
  };
}

export function transformCommodityProfileApiResponseToCategoryProductSheet(
  apiResponse: TProductProfileApiResponse,
) {
  return {
    ...apiResponse,
    display: Boolean(apiResponse?.display),
    fresh: Boolean(apiResponse?.fresh),
    shelfLife: Number(apiResponse?.shelfLife),
    shelfLifeUnit: apiResponse?.shelfLifeUnit?.id,
    unitsOfMeasure: {
      units: (apiResponse?.unitsOfMeasure?.units || []).map(unit => unit.id),
      default:
        apiResponse?.unitsOfMeasure?.units?.find(unit => unit.is_default)?.id ||
        0,
    },
  };
}

export function transformMenuItemProfileApiResponseToProductSheet(
  apiResponse: TMenuItemProfileApiResponse,
): TProductSheetResponse {
  return {
    ...apiResponse,
    display: Boolean(apiResponse?.onProductionSheet),
    fresh: Boolean(apiResponse?.fresh),
    shelfLife: Number(apiResponse?.shelfLife),
    shelfLifeUnit: Number(apiResponse?.shelfLifeUnit),
    unitsOfMeasure: {
      units: apiResponse?.unitsOfMeasure?.units || [],
      default: apiResponse?.unitsOfMeasure?.default || 0,
    },
  };
}
